const AUTH_KEYS = ['access_token', 'refresh_token', 'user_role', 'user'];

function getStorageItem(storage, key) {
	try {
		return storage.getItem(key);
	} catch (e) {
		return '';
	}
}

function setStorageItem(storage, key, value) {
	try {
		if (value === undefined || value === null) {
			storage.removeItem(key);
		} else {
			storage.setItem(key, value);
		}
	} catch (e) {}
}

function removeStorageItem(storage, key) {
	try {
		storage.removeItem(key);
	} catch (e) {}
}

export function saveAuth(auth) {
	const user = {
		...getCurrentUser(),
		...(auth || {}),
	};
	const values = {
		access_token: user.access_token || '',
		refresh_token: user.refresh_token || '',
		user_role: user.user_role || '',
		user: JSON.stringify(user),
	};
	AUTH_KEYS.forEach((key) => {
		setStorageItem(sessionStorage, key, values[key]);
		setStorageItem(localStorage, key, values[key]);
	});
}

export function restoreAuthSession() {
	let restored = false;
	AUTH_KEYS.forEach((key) => {
		const sessionValue = getStorageItem(sessionStorage, key);
		const localValue = getStorageItem(localStorage, key);
		if (!sessionValue && localValue) {
			setStorageItem(sessionStorage, key, localValue);
			restored = true;
		}
	});
	return restored;
}

export function getAuthItem(key) {
	const sessionValue = getStorageItem(sessionStorage, key);
	if (sessionValue) {
		return sessionValue;
	}
	restoreAuthSession();
	return getStorageItem(sessionStorage, key) || getStorageItem(localStorage, key) || '';
}

export function getAccessToken() {
	return getAuthItem('access_token');
}

export function getRefreshToken() {
	return getAuthItem('refresh_token');
}

export function getUserRole() {
	return getAuthItem('user_role');
}

export function getCurrentUser() {
	const userText = getAuthItem('user');
	if (!userText) {
		return {};
	}
	try {
		return JSON.parse(userText) || {};
	} catch (e) {
		return {};
	}
}

export function clearAuth() {
	AUTH_KEYS.forEach((key) => {
		removeStorageItem(sessionStorage, key);
		removeStorageItem(localStorage, key);
	});
}



// WEBPACK FOOTER //
// ./src/utils/auth.js